import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const ACTIVE_TENANT_KEY = "trf_active_tenant_id";

// Rutas admin que NO deben recibir el query param `tenant_id` (ya lo llevan
// en el path o no aplica): /admin/tenants (root), /admin/dashboard-operacion.
// Sí lo aplican: /admin/tenants/:id/* (que reciben el tid en la path), pero
// como no lo usan como query, no colisiona.
function shouldAppendTenant(url) {
    if (!url) return false;
    if (url.startsWith("/tenants/current")) return true;
    // el resto de rutas de admin/tenants NO llevan query tenant_id, usan path
    if (url.startsWith("/admin/tenants")) return false;
    if (url.startsWith("/admin/dashboard-operacion")) return false;
    return true;
}

const api = axios.create({
    baseURL: API_BASE,
    timeout: 30000,
});

api.interceptors.request.use((config) => {
    const token = localStorage.getItem("trf_token");
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    // Fase 4: si el usuario es super_admin y está impersonando otro tenant,
    // adjuntar `?tenant_id=xxx` transparentemente.
    const active = localStorage.getItem(ACTIVE_TENANT_KEY);
    if (active && shouldAppendTenant(config.url || "")) {
        config.params = { ...(config.params || {}), tenant_id: active };
    }
    return config;
});

api.interceptors.response.use(
    (r) => r,
    (err) => {
        if (err.response?.status === 401) {
            const path = window.location.pathname;
            if (!path.startsWith("/login")) {
                localStorage.removeItem("trf_token");
                localStorage.removeItem("trf_user");
                localStorage.removeItem(ACTIVE_TENANT_KEY);
                window.location.href = "/login";
            }
        }
        return Promise.reject(err);
    },
);

export default api;
